import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GitlabFilledSvg from "@ant-design/icons-svg/es/asn/GitlabFilled";
import AntdIcon from '../components/AntdIcon';
var GitlabFilled = function GitlabFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: GitlabFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(GitlabFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'GitlabFilled';
}
export default RefIcon;